import { chainsQueries } from "@/src/solana/chains/queries.js";

export function sortDeployments<T extends { chainId: number }>(deployments: T[]): T[] {
  return deployments.toSorted((a, b) => {
    const aChain = chainsQueries.getOrThrow(a.chainId);
    const bChain = chainsQueries.getOrThrow(b.chainId);
    return aChain.name.localeCompare(bChain.name);
  });
}
